import { ContentReplaceStatus } from 'app/library/scorm/enums/content-replace-status.enum';
import { SectionType } from '../enums/section-type.enum';
import { ISectionQuery } from '../interfaces/section.query.interface';
import { Section } from './section.model';

export class ELearningSection extends Section {
    courseImportJobId: string;
    courseId: string;
    contentUpdatedAt: string | null;
    contentReplaceStatus: ContentReplaceStatus | null;

    constructor(query?: ISectionQuery) {
        super(query);

        this._type = SectionType.ELearning;

        if (query) {
            this.courseImportJobId = query.course_import_job_id;
            this.courseId = query.course_id;
            this.contentUpdatedAt = query.content_updated_at ?? null;
            this.contentReplaceStatus = (query.content_replace_status as ContentReplaceStatus) || null;
        }
    }
}
